module.exports = __webpack_public_path__ + "static/media/stripe_tag.f329a8ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stripe_tag.svg
// module id = 2078
// module chunks = 0